import styled from '@mui/material/styles/styled';

export const StorySectionContainer = styled('div')(({ theme }) => ({
  /* Prevent horizontal overflow/bounce on mobile from pitch deck HTML content */
  overflowX: 'hidden',
  '& *': {
    maxWidth: '100% !important',
    boxSizing: 'border-box !important',
  },
  [theme.breakpoints.down('lg')]: {
    wordBreak: 'break-word',
  },
  /* Mobile-specific styles to prevent content overflow */
  [theme.breakpoints.down('md')]: {
    '& div, & span:not(.fr-video), & p, & section, & article, & strong, & a': {
      overflowX: 'hidden',
    },
    /* Allow visible overflow on elements that directly wrap images (e.g. <strong> tags
       from Froala editor) so images are not clipped on mobile viewports */
    '& strong:has(> img), & span:has(> img), & a:has(> img), & p:has(> img)': {
      overflowX: 'visible !important',
    },
    '& img': {
      height: 'auto !important',
      width: 'auto !important',
      maxWidth: '100% !important',
    },
    '& svg': {
      maxWidth: '100% !important',
      height: 'auto !important',
    },
    '& table': {
      tableLayout: 'fixed',
      width: '100% !important',
      maxWidth: '100% !important',
    },
    '& td, & th': {
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
    },
    '& pre, & code': {
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
    },
  },
  section: {
    maxWidth: '100% !important',
  },
  '.image-max-width': {
    maxWidth: '100% !important',
  },
  img: {
    maxWidth: '100% !important',
    height: 'auto',
  },
  video: {
    maxWidth: '100% !important',
  },
  /* Override aspect-ratio rule for videos to respect native dimensions */
  '.fr-video video, .campaign-story .fr-video video, .bootstrap-iso .fr-video video': {
    aspectRatio: 'unset !important',
    width: '100% !important',
    height: 'auto !important',
  },
  /* Note: padding-bottom undo for native video elements handled below with .fr-dvb:has(video) rule */
  '.bootstrap-iso .fr-view .fr-video.fr-dvb': {
    height: 'auto',
  },
  '.fp-no-block.fp-no-sections': {
    display: 'none !important',
  },
  '.fr-toolbar': {
    display: 'none !important',
  },
  '.fr-popup': {
    display: 'none !important',
  },
  '.fr-quick-insert': {
    display: 'none !important',
  },
  '.fr-image-resizer': {
    display: 'none !important',
  },
  '.fr-qi-helper': {
    display: 'none !important',
  },
  [theme.breakpoints.up('md')]: {
    '.container': {
      maxWidth: '740px !important',
    },
    '.story-image': {
      maxWidth: '740px !important',
    },
    '.story-paragraph': {
      maxWidth: '740px !important',
    },
  },
  '& .fr-video > iframe': {
    maxWidth: '100% !important',
    pointerEvents: 'auto !important',
    position: 'absolute !important',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: '1 !important',
  },
  '& .fr-video': {
    pointerEvents: 'auto !important',
    display: 'block !important',
    boxSizing: 'content-box !important',
    position: 'relative !important',
    width: '100% !important',
    /* Force GPU compositing layer on iOS Safari to render iframe content */
    WebkitTransform: 'translateZ(0)',
    transform: 'translateZ(0)',
    /* Override Froala overflow:hidden which prevents iframe rendering on iOS */
    overflow: 'visible !important',
  },
  'span:has(> .fr-video), span:has(> .fr-fvc)': {
    display: 'block !important',
    width: '100% !important',
  },
  /* Ensure Froala video block containers have aspect ratio for iframes */
  '.fr-video.fr-dvb, .fr-fvc.fr-dvb': {
    position: 'relative !important',
    height: '0 !important',
    overflow: 'hidden !important',
    width: '100% !important',
    marginLeft: '0 !important',
    marginRight: '0 !important',
  },
  /* Undo padding-bottom for containers with native video (not iframes) */
  '.fr-video.fr-dvb:has(video), .fr-fvc.fr-dvb:has(video)': {
    paddingBottom: '0 !important',
    height: 'auto !important',
  },
  /* Prevent parent spans from clipping iframe content on iOS Safari */
  'span:has(> .fr-video)': {
    overflow: 'visible !important',
    overflowX: 'visible !important',
  },
  /* Disable Froala draggable overlay on videos */
  '.fr-draggable::after, .fr-draggable::before': {
    display: 'none !important',
    pointerEvents: 'none !important',
  },
  '.fr-draggable': {
    pointerEvents: 'auto !important',
    userSelect: 'auto !important',
  },
  '.fr-view img.fr-dib.fr-fil': {
    marginLeft: 0,
    textAlign: 'left',
  },
  '.fr-view img.fr-dib, .fr-view img.fr-fic.fr-dib': {
    margin: '24px auto',
  },
  '.fr-line-breaker': {
    display: 'none !important',
  },
  '.fr-video-resizer': {
    display: 'none !important',
  },
  '.fr-code': {
    display: 'none !important',
  },
  '.fr-command': {
    display: 'none !important',
  },
  '.fr-selection-handle': {
    display: 'none !important',
  },
  '.fr-second-toolbar': {
    display: 'none !important',
  },
  '.fr-table-selector': {
    display: 'none !important',
  },
  '.fr-table-selector-inactive': {
    display: 'none !important',
  },
  '.fdb-block a': {
    textDecoration: 'none',
  },
  '.fdb-block .bootstrap-iso': {
    backgroundColor: 'transparent !important',
    fontFamily: 'IBM Plex Sans !important',
  },
  '& .fr-video iframe[src*="youtube.com"], & .fr-video iframe[src*="vimeo.com"]': {
    aspectRatio: '16 / 9',
    width: '100% !important',
    height: '100% !important',
  },
  'a[href*="froala.com"], p.fr-badge, [data-f-id="pbf"]': {
    display: 'none !important',
  },
}));
